import { vars } from "plos/src/styles";
import { style } from "@vanilla-extract/css";

export const howCupsWorkTitle = style({
  fontSize: vars.fontSizes.heading.m,
});

export const howCupsWorkWrapper = style({
  display: "grid",
  gap: vars.space.m,
});

export const listItems = style({
  marginInlineStart: vars.space.m,
  listStyle: "disc",
});

export const dividerWrapper = style({
  padding: `${vars.space.m} 0`,
});
